// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5608) return "static/chunks/5608-1edb96e275086d06.js";
	if (chunkId === 9334) return "static/chunks/9334-3f20346fced2ee02.js";
	if (chunkId === 8765) return "static/chunks/8765-73b335754a094ef9.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4959":"4a6da7b02207aaad","6294":"36715368c90e7900","6691":"bead5cf36bdfb07b","6793":"f57464ca23fa9330"}[chunkId] + ".js";
};